module.exports = true;



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/_library.js
// module id = 9
// module chunks = 0